// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"436":"49944368","453":"1f4ec34d","824":"0a99e0d5"}[chunkId] + ".chunk.js";
};